/**
 * The history state of a link from one docs page to another: the previous
 * and next links at the bottom, and the links in the text. The page it opens
 * moves focus to its title, so a keyboard or screen reader user starts
 * reading there, instead of losing focus with the page the link was on.
 */
export const FOCUS_DOC_TITLE = { focusDocTitle: true } as const;

/** Whether a page was opened by such a link, from its location's state. */
export function focusesDocTitle(state: unknown): boolean {
  return typeof state === "object" && state !== null && "focusDocTitle" in state;
}
